import * as React from "react";

import * as PropTypes from "../prop-types";
import { PropsType } from "../PropsType";
import { spsGlobalPropTypes } from "../util";

import { SpsButton } from "../index";
import { ButtonKind } from "@spscommerce/ds-shared";

export const propTypes = {
    ...spsGlobalPropTypes,
    kind: PropTypes.enumValue<ButtonKind>(ButtonKind)
};

export type SpsTabbedNavProps = PropsType<typeof propTypes> & React.HTMLAttributes<HTMLButtonElement>;

export function SpsTabbedNavItem(props: SpsTabbedNavProps) {
    const {
        children,
        className,
        kind,
        "data-testid": testId,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    return (
        <SpsButton kind={kind} {...rest} />
    );
}

Object.assign(SpsTabbedNavItem, {
    propTypes,
    displayName: "SpsTabbedNavItem"
});